import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UserHeader from "../../Component/UserHeader";
import UserSidebar from "../../Component/UserSidebar";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import { bindActionCreators } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import StudentSignup from "./UpdateProfileStep5";
import { fetchDomains, fetchObjectives } from "./Slice/updateProfile4Slice";
import PropTypes from "prop-types";




  function SidebarAddClass() {
    document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
  }

  function SidebarRemoveClass() {
    document.getElementById("OnscrollBody").classList.remove("show_sidebar");
  }

    
const UpdateProfile4 = (props) => {
  const dispatch = useDispatch();
  const { domains, objectives, loading } = useSelector((state) => state?.updateProfile4);
  const userInfo = useSelector((state) => state?.userInfo);
  const { title, updateProfileData } = props;
  const [selectedObjective, setSelectedObjective] = useState([]);

  useEffect(() => {
    document.title = title || "Complete/ Edit Profile";

    dispatch(fetchDomains());

    if (userInfo?.role_id) {
      dispatch(fetchObjectives(userInfo.role_id));
    }
  }, [dispatch, userInfo?.role_id, title]);



  useEffect(() => {
    if (updateProfileData) {
      if (updateProfileData.objective) {
        setSelectedObjective(updateProfileData.objective.split(","));
      }
    }
  }, [updateProfileData]);

  return (
    <div>
      <UserHeader />

      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to="#"
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h2 className="page_heading mb-3">Complete/ Edit Profile</h2>

          <div className="box shadow bg-white p-md-5">
            <div className="studentformdashboard pt-md-4">
              {/* <StudentSignup type='profile' /> */}
              <StudentSignup
                type="profile"
                domains={domains}
                objectives={objectives}
                selectedObjective={selectedObjective}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
      <input
        type="button"
        className="sidebar_overlay"
        onClick={SidebarRemoveClass}
        aria-label="Close sidebar overlay"
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    isData: state.isData,
    updateProfileData: state.updateProfileData,
    isLoad: state.isLoad,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userAction,
        ...baseActions,
      },
      dispatch
    ),
  };
}

UpdateProfile4.propTypes = {
  title: PropTypes.string,  
  updateProfileData: PropTypes.shape({
    objective: PropTypes.string,
  }),

};
export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile4);

